import { Organization } from "app/organization/organization.model";
import { CrudAbstractModel } from "../crud-abstract/crud-abstract.model";
import { Company } from "app/company/company.model";
export class Notification extends CrudAbstractModel {
  constructor(
    public id: number,
    public status: string,
    public title: string,
    public body: string,
    public createdAt: Date,
    public highlighted: boolean,
    public organization?: Organization,
    public companies?: Company[],
    public read?: boolean,
  ) {
    super(id);
  }

  public getId(): number {
    return this.id;
  }

  public isHiglighted(): boolean {
    return this.highlighted;
  }

  public setHighlighted(value: boolean) {
    this.highlighted = value;
  }

  public isRead(): boolean {
    return this.read;
  }

  public setRead(value: boolean) {
    this.read = value;
  }

  public getRequestParams() {
    return {
      status: this.status,
      title: this.title,
      body: this.body,
      highlighted: this.highlighted,
      organization: this.organization ? this.organization.id : null,
      companies: this.companies
        ? this.companies.map((company) => company["id"])
        : [],
    };
  }
}
